export default function getFileSize(byteSize) {
	let fileSize = {};

	if (byteSize > 1024 * 1024) {
		fileSize.value = Math.round((byteSize * 100) / (1024 * 1024)) / 100;
		fileSize.suffix = "MB";
	} else {
		fileSize.value = Math.round((byteSize * 100) / 1024) / 100;
		fileSize.suffix = "KB";
	}

	return fileSize;
}



// WEBPACK FOOTER //
// ./src/utils/fileSize.js